export const ThemeManagerEndpoint = {
  THEME_MANAGER_LOAD_THEMES: '/default/theme-manager/load-themes',
  THEME_MANAGER_CREATE_CUSTOM_THEME: '/default/theme-manager/create-custom-theme',
  THEME_MANAGER_CREATE_DEFAULT_THEME: '/default/theme-manager/create-default-theme',
  THEME_MANAGER_UPDATE_THEME: '/default/theme-manager/update-theme',
  THEME_MANAGER_DELETE_THEME: '/default/theme-manager/delete-theme',
  THEME_MANAGER_LOAD_CONTACT_LIST: '/default/theme-manager/load-contact-list',
  THEME_MANAGER_GET_USER_RELATIONS: '/default/theme-manager/get-user-relations',
};
